import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Admin pages
import Login from 'src/components/Dashboard/Views/Login.vue'
import Categories from 'src/components/Dashboard/Views/Categories.vue'
import CreateCategory from 'src/components/Dashboard/Views/Category/Create.vue'
import EditCategory from 'src/components/Dashboard/Views/Category/Edit.vue'
import ImagesCategories from 'src/components/Dashboard/Views/ImagesCategories.vue'
import ImagesCreateCategory from 'src/components/Dashboard/Views/ImagesCategory/Create.vue'
import ImagesEditCategory from 'src/components/Dashboard/Views/ImagesCategory/Edit.vue'
import Quotes from 'src/components/Dashboard/Views/Quotes.vue'
import CreateQuote from 'src/components/Dashboard/Views/Quote/Create.vue'
import EditQuote from 'src/components/Dashboard/Views/Quote/Edit.vue'
import Images from 'src/components/Dashboard/Views/Images.vue'
import CreateImage from 'src/components/Dashboard/Views/Image/Create.vue'
import EditImage from 'src/components/Dashboard/Views/Image/Edit.vue'
import Icons from 'src/components/Dashboard/Views/Icons.vue'
import Auth from '../middleware/Auth'
import Viewer from "../middleware/Viewer";

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/',
        redirect: "/quotes",
        component: DashboardLayout,
        children: [
            {
                path: 'categories',
                name: 'Categories',
                component: Categories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'categories/create',
                name: 'create-category',
                component: CreateCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'categories/:id',
                name: 'edit-category',
                component: EditCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'quotes',
                name: 'Quotes',
                component: Quotes,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'quotes/create',
                name: 'create-quote',
                component: CreateQuote,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'quotes/:id',
                name: 'edit-quote',
                component: EditQuote,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'images-categories',
                name: 'ImagesCategories',
                component: ImagesCategories,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'images-categories/create',
                name: 'create-images-category',
                component: ImagesCreateCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'images-categories/:id',
                name: 'edit-images-category',
                component: ImagesEditCategory,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'images',
                name: 'Images',
                component: Images,
                meta: {
                    middleware: [Viewer]
                },
            },
            {
                path: 'images/create',
                name: 'create-image',
                component: CreateImage,
                meta: {
                    middleware: [Auth]
                },
            },
            {
                path: 'images/:id',
                name: 'edit-image',
                component: EditImage,
                meta: {
                    middleware: [Auth]
                },
            },







            {
                path: 'icons',
                name: 'Icons',
                component: Icons,
                // meta: {
                //     middleware: [Auth]
                // },
            },
        ]
    },
    {path: '*', component: NotFound}
];

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js